"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const extractHashtags_1 = require("./extractHashtags");
exports.default = (inputString = '') => {
    return inputString.search(extractHashtags_1.hashtagRegex) >= 0;
};
